// Featured images for posts, keyed by slug.
// To add an image: drop the file in src/Aseets/ and add one line below.
import artOfIllusionImg from "../Aseets/art-of-illusion.jpg";
import top5AiImg from "../Aseets/top-5-ai-apps.jpg";
import aiToolsImg from "../Aseets/ai-tools.jpg";
import enhancefoxImg from "../Aseets/enhancefox.jpg";
import reminiImg from "../Aseets/remini.jpg";
import autoPhotoEditImg from "../Aseets/automatic-photo-editing.jpg";
// APK category
import tataNeuImg from "../Aseets/tata-neu.jpg";
import fouadImg from "../Aseets/fouad-whatsapp.jpg";
import skrwtImg from "../Aseets/skrwt.jpg";
import movieRulzImg from "../Aseets/movie-rulz.jpg";
import notifPanelImg from "../Aseets/notification-panel.jpg";
import quickshotImg from "../Aseets/enlight-quickshot.jpg";
import powerDirectorImg from "../Aseets/power-director.jpg";
import peacockImg from "../Aseets/peacock-tv.jpg";
// Applications category
import nubiaImg from "../Aseets/nubia-redmagic.jpeg";
import railoneImg from "../Aseets/railone-app.jpg";
import boiImg from "../Aseets/boi-omni.jpg";
import appsHelpsImg from "../Aseets/apps-helps-you.jpg";
import latestAndroidImg from "../Aseets/latest-android-apps.jpg";
import pixlrImg from "../Aseets/pixlr-suite.jpg";
import latestTechFeatureImg from "../Aseets/latest-tech-feature.jpg";
import facetoonImg from "../Aseets/facetoon.jpg";
import removeBgImg from "../Aseets/remove-background.jpg";
import hiddenProImg from "../Aseets/hidden-pro-apps.jpg";
import latestTechImg from "../Aseets/latest-tech-apps.jpg";
import conductiveImg from "../Aseets/conductive-apps.jpg";
import motionNinjaImg from "../Aseets/motion-ninja.jpg";
import bestAppsTryImg from "../Aseets/best-apps-try-now.jpg";
// Editing apps category
import relensImg from "../Aseets/relens-camera.jpg";
import vnAddSongImg from "../Aseets/vn-add-song.jpeg";
import vnLyricalImg from "../Aseets/vn-lyrical.jpeg";
import prettyUpImg from "../Aseets/pretty-up.jpg";
import photoToVideoImg from "../Aseets/photo-to-video.jpg";
import vidsiImg from "../Aseets/vidsi.jpg";
import photoQualityImg from "../Aseets/photo-quality-enhance.jpg";
// Free Fire Diamonds Trick category
import ffSeasonPassImg from "../Aseets/ff-season-pass.jpg";
import ff2022SecureImg from "../Aseets/ff-2022-secure.jpg";
import ffGenuineUpiImg from "../Aseets/ff-genuine-upi.jpg";
import ffFrizzaImg from "../Aseets/ff-frizza.jpg";
import ffEarneasyImg from "../Aseets/ff-earneasy.jpeg";
import ffWinnerhubImg from "../Aseets/ff-winnerhub.jpg";
import ffBest2022Img from "../Aseets/ff-best-2022.jpg";
import ffWithoutHardImg from "../Aseets/ff-without-hard.jpg";
import ffYrgamingImg from "../Aseets/ff-yrgaming.jpg";
// Free Fire Tricks category
import ffRedeemImg from "../Aseets/ff-redeem-code.jpeg";
import ffShot1Img from "../Aseets/ff-shot1.jpg";
import ffShot2Img from "../Aseets/ff-shot2.jpg";
import ffShot3Img from "../Aseets/ff-shot3.jpg";
import ffShot4Img from "../Aseets/ff-shot4.jpg";
import ffShot5Img from "../Aseets/ff-shot5.jpg";
// Freefire Max Diamonds category
import ffmaxInstantImg from "../Aseets/ffmax-instant.jpg";
import ffmaxEasilyImg from "../Aseets/ffmax-easily.jpg";
import ffdShot1Img from "../Aseets/ffd-shot1.jpg";
import ffdShot2Img from "../Aseets/ffd-shot2.jpg";
import redeemcoin from '../Aseets/reedem-code.jpg'
// Games category
import gameMiriamImg from "../Aseets/game-miriam.jpg";
import game1mbImg from "../Aseets/game-1mb.jpeg";
import gameSubwayImg from "../Aseets/game-subway.jpg";
import gameSolitaireImg from "../Aseets/game-solitaire.jpg";
import gameMagicalImg from "../Aseets/game-magical.jpg";
// How To category
import howtoBrainImg from "../Aseets/howto-brain.jpeg";
import howtoLocationImg from "../Aseets/howto-location.jpg";
import howtoRestoreImg from "../Aseets/howto-restore.jpeg";
import howtoDualcamImg from "../Aseets/howto-dualcam.jpg";
import howtoAmpereImg from "../Aseets/howto-ampere.jpg";
import howto90fpsImg from "../Aseets/howto-90fps.jpg";
import howtoWebsitesImg from "../Aseets/howto-websites.jpg";
// iPhone apps category
import xmeyeImg from "../Aseets/xmeye.jpg";
import iphoneBestImg from "../Aseets/iphone-best.jpg";
import iphoneEditingImg from "../Aseets/iphone-editing.jpg";
import iphoneProductivityImg from "../Aseets/iphone-productivity.jpg";
import iphoneGamesImg from "../Aseets/iphone-games.jpg";
import iphonePrivacyImg from "../Aseets/iphone-privacy.jpg";
// Tech News category
import techWatoolsImg from "../Aseets/tech-watools.jpg";
import techChinaAltImg from "../Aseets/tech-china-alt.jpg";
import techApsrtcImg from "../Aseets/tech-apsrtc.jpg";
import techFlipkartImg from "../Aseets/tech-flipkart.jpg";
import techWhatsappImg from "../Aseets/tech-whatsapp.jpg";
import techGpayImg from "../Aseets/tech-gpay.jpg";
import techAndroidImg from "../Aseets/tech-android.jpg";
import techSmartphoneImg from "../Aseets/tech-smartphone.jpg";
// Top 5 category
import top5SurprisingImg from "../Aseets/top5-surprising.jpg";
import top5WebsitesImg from "../Aseets/top5-websites.jpg";
import top5NotPlaystoreImg from "../Aseets/top5-notplaystore.jpg";
import top5CrazyImg from "../Aseets/top5-crazy.jpg";
import top5HightechImg from "../Aseets/top5-hightech.jpg";
import top5SimpleImg from "../Aseets/lessthan50.png";
import top5InterestingImg from "../Aseets/top5-interesting.jpg";
import top5SpecialImg from "../Aseets/top5-special.jpg";
import variouspurposeImg from "../Aseets/various-purpos.jpg";
// Top 5 Games category
import t5gRacingImg from "../Aseets/t5g-racing.jpg";
import t5gCricketImg from "../Aseets/t5g-cricket.jpg";
import t5gMindfreshImg from "../Aseets/t5g-mindfresh.jpg";
import t5gChildhoodImg from "../Aseets/t5g-childhood.jpg";
import t5gBattleImg from "../Aseets/t5g-battle.jpg";
import t5gMultiplayerImg from "../Aseets/t5g-multiplayer.jpg";
import t5gLowmbImg from "../Aseets/t5g-lowmb.jpg";
// Top Apps category
import taJuly2022Img from "../Aseets/ta-july2022.jpg";
import ta1mbImg from "../Aseets/ta-1mb.jpg";
import taAmazingImg from "../Aseets/ta-amazing.jpg";
import taSharpImg from "../Aseets/ta-sharp.jpg";
import taHighusefulImg from "../Aseets/ta-highuseful.jpg";
import taSimpleusesImg from "../Aseets/ta-simpleuses.jpg";
import taTrickyImg from "../Aseets/ta-tricky.jpg";
// Updates category
import upSimcardsImg from "../Aseets/up-simcards.jpg";
import upKmplayerImg from "../Aseets/up-kmplayer.jpg";
import upSandesImg from "../Aseets/up-sandes.jpeg";
import upTriveindImg from "../Aseets/up-triveind.jpg";
import upRewardsImg from "../Aseets/up-rewards.jpeg";
import upMoneyrainImg from "../Aseets/up-moneyrain.jpg";

const postImages = {
  // AI apps category
  "art-of-illusion-tool-app": artOfIllusionImg,
  "top-5-ai-apps-for-android": top5AiImg,
  "5-best-free-ai-tool": aiToolsImg,
  "enhancefox-ai-photo-enhancer-to-better-quality": enhancefoxImg,
  "remini-photo-enhancer": reminiImg,
  "top-5-automatic-photo-editing-apps": autoPhotoEditImg,
  // APK category
  "tata-neu-app-apk-for-android": tataNeuImg,
  "fouad-whatsapp": fouadImg,
  "skrwt-app-download-mod": skrwtImg,
  "movie-rulz-app": movieRulzImg,
  "photo-in-notification-panel-stylish": notifPanelImg,
  "enlight-quickshot-photo-editor-mod-apk": quickshotImg,
  "power-director-pro-version-android-apk": powerDirectorImg,
  "peacock-tv-app-apk-for-android": peacockImg,
  // Applications category
  "mobile-nubia-redmagic-launcher": nubiaImg,
  "railone-app-download": railoneImg,
  "boi-mobile-omni-neo-bank-app-2-0-0": boiImg,
  "5-apps-helps-you-definitely": appsHelpsImg,
  "latest-android-apps": latestAndroidImg,
  "best-photo-editing-app-pixlr-suite": pixlrImg,
  "5-latest-android-apps": latestTechFeatureImg,
  "facetoon-app": facetoonImg,
  "best-remove-background-app": removeBgImg,
  "best-hidden-pro-apps": hiddenProImg,
  "latest-technology-apps-for-android": latestTechImg,
  "5-best-conductive-apps-for-android-in-2023": conductiveImg,
  "motion-ninja-app-android": motionNinjaImg,
  "best-apps-for-android-try-now": bestAppsTryImg,
  // Editing apps category
  "focus-dslr-relens-camera-app": relensImg,
  "favourite-song-to-existing-video-editing-app": vnAddSongImg,
  "best-trending-images-to-video-lyrical-vn-app": vnLyricalImg,
  "pretty-up-video-body-editor-app": prettyUpImg,
  "photo-to-video-creator-app-with-amazing-auto-effects": photoToVideoImg,
  "how-to-create-intro-outro-demo-vidsi-app": vidsiImg,
  "best-photo-quality-enhancing-android-apps-free-paid": photoQualityImg,
  // Free Fire Diamonds Trick category
  "how-to-get-free-fire-max-diamonds": ffSeasonPassImg,
  "get-free-diamonds-in-free-fire-max-2022": ff2022SecureImg,
  "very-genuine-way-to-get-freefire-max-diamonds": ffGenuineUpiImg,
  "freefire-max-game-diamonds-free-rewards-app": ffFrizzaImg,
  "get-free-diamonds-in-free-fire-max": ffEarneasyImg,
  "how-to-get-freefire-diamonds-bgmi-uc": ffWinnerhubImg,
  "best-method-to-get-freefire-diamonds-in-2022": ffBest2022Img,
  "obtain-ffdiamonds-using-new-method": ffWithoutHardImg,
  "how-to-get-free-fire-diamonds-from-yrgaming": ffYrgamingImg,
  // Free Fire Tricks category
  "generating-garena-free-fire-code": ffRedeemImg,
  "best-free-fire-sensitivity-settings-headshots": ffShot1Img,
  "best-free-fire-settings-low-end-phones": ffShot2Img,
  "free-fire-tips-tricks-rank-up-fast": ffShot3Img,
  "best-free-fire-custom-hud-control-layout": ffShot4Img,
  "best-free-fire-character-pet-combinations": ffShot5Img,
  // Freefire Max Diamonds category
  "new-trick-to-get-instant-freefire-max-diamonds-in-your-id": ffmaxInstantImg,
  "get-free-fire-diamonds-easily": ffmaxEasilyImg,
  "free-fire-max-diamonds-legally-reward-apps": ffdShot1Img,
  "free-fire-max-diamond-top-up-save-money": ffdShot2Img,
  "free-fire-max-membership-worth-it": ffShot1Img,
  "free-fire-redeem-codes-free-rewards-guide": redeemcoin,
  "free-fire-diamond-royale-events-best-value": ffShot3Img,
  // Games category
  "best-offline-high-graphics-game-app-for-android": gameMiriamImg,
  "1-mb-games-try-now": game1mbImg,
  "best-comic-game-subway-jungle-surf": gameSubwayImg,
  "solitaire-sea-collect-rewards": gameSolitaireImg,
  "earn-free-fire-diamonds-app-magical-numbers": gameMagicalImg,
  // How To category
  "improve-brain-power-5-techniques": howtoBrainImg,
  "how-to-find-person-location": howtoLocationImg,
  "how-to-restrore-permanently-deleted-images-videos-in-mobile": howtoRestoreImg,
  "how-to-switch-front-and-back-camera-while-recording-video": howtoDualcamImg,
  "best-app-to-check-charging-current-ampere-app-android": howtoAmpereImg,
  "get-90fps-in-pubg-in-all-mobiles": howto90fpsImg,
  "5-simple-websites-features": howtoWebsitesImg,
  // iPhone apps category
  "xmeye-mac-iphone": xmeyeImg,
  "best-free-iphone-apps-2026": iphoneBestImg,
  "best-iphone-photo-video-editing-apps": iphoneEditingImg,
  "best-iphone-productivity-apps": iphoneProductivityImg,
  "best-free-iphone-games": iphoneGamesImg,
  "best-iphone-privacy-security-apps": iphonePrivacyImg,
  // Tech News category
  "android-15-new-features": techAndroidImg,
  "whatsapp-tips-and-tricks-watools-app": techWatoolsImg,
  "best-10-alternate-apps-to-china-apps-update-to-indian-global-apps": techChinaAltImg,
  "apsrtc-pratham-app-get-5": techApsrtcImg,
  "big-billion-day-best-offers-flipkart-amazon": techFlipkartImg,
  "whatsapp-new-features-2026": techWhatsappImg,
  "best-upcoming-smartphones-2026": techSmartphoneImg,
  "upi-digital-payments-latest-updates": techGpayImg,
  // Top 5 category
  "top-5-surprising-android-apps": top5SurprisingImg,
  "top-5-amazing-websites-unknown": top5WebsitesImg,
  "5-apps-not-available-in-playstore-check-list-app-uses": top5NotPlaystoreImg,
  "top-5-crazy-apps-for-android-different": top5CrazyImg,
  "5-high-technology-apps-for-android": top5HightechImg,
  "very-simple-5-android-apps": top5SimpleImg,
  "interesting-best-5-apps-for-android-try-now": top5InterestingImg,
  "top-5-apps-for-android-special": top5SpecialImg,
  "5-android-apps-to-use-in-various-purposes": variouspurposeImg,
  // Top 5 Games category
  "5-best-car-racing-games": t5gRacingImg,
  "top-5-best-cricket-games": t5gCricketImg,
  "simple-attractive-mind-fresh-top-5-android-games": t5gMindfreshImg,
  "5-childhood-attractive-games-android": t5gChildhoodImg,
  "top-5-battle-royale-games-android": t5gBattleImg,
  "top-5-multiplayer-games-play-with-friends": t5gMultiplayerImg,
  "top-5-low-mb-offline-games-android": t5gLowmbImg,
  // Top Apps category
  "top-5-july-2022-best-latest-useful-android-apps": taJuly2022Img,
  "10-apps-under-1mb-awesome": ta1mbImg,
  "5-simple-amazing-feature-applications": taAmazingImg,
  "best-5-sharp-android-apps-in-2022": taSharpImg,
  "five-best-high-useful-android-mobile-apps": taHighusefulImg,
  "simple-uses-top-5-android-apps": taSimpleusesImg,
  "top-5-five-tricky-time-saving-android-apps": taTrickyImg,
  // Updates category
  "sim-cards-registered-in-your-proof-id-adhar": upSimcardsImg,
  "kmplayer-app": upKmplayerImg,
  "sandes-message-app": upSandesImg,
  "new-triveind-app-to-get-more-diamonds": upTriveindImg,
  "get-rewards-free-fire-diamonds": upRewardsImg,
  "interesting-game-app-to-earn-free-fire-diamonds": upMoneyrainImg,
};

// Returns the post-specific image if one exists (otherwise undefined).
export const getPostImage = (post) => (post ? postImages[post.slug] : undefined);

export default postImages;
